// Service workers are retired so CloudFront releases are available immediately.

export default function register() {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', retireServiceWorkers);
  }
}

function retireServiceWorkers() {
  const reloadKey = 'hoopstir-service-worker-retired';
  navigator.serviceWorker.getRegistrations().then(registrations => {
    if (!registrations.length) return;

    return Promise.all(registrations.map(registration => registration.unregister())).then(() => {
      let alreadyReloaded = false;
      try {
        alreadyReloaded = window.sessionStorage.getItem(reloadKey) === 'true';
        window.sessionStorage.setItem(reloadKey, 'true');
      } catch (error) {
        // Some privacy modes block sessionStorage; leave the current page usable.
      }

      if (!alreadyReloaded) window.location.reload();
    });
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => registration.unregister());
    });
  }
}
